import { memo } from 'react';
import { CLIP_CUSTOMIZER_LAYOUT_TYPES } from '@goldcast/player-config/src/constants/layouts.constants';
import { LayoutType } from '@goldcast/player-config/src/types/asset-types';
import ClipCustomizerMagicLayoutIconButton from './ClipCustomizerMagicLayoutIconButton';
import { LayoutPopupOption } from '../../ClipCustomizer/Layout/constants';
import useMagicLayoutSelection from './useMagicLayoutSelection';
import ConfirmationDialog from '@/components/organisms/ConfirmationDialog';

function ClipCustomizerMagicLayoutOption({
  magicLayoutOption,
  disabled,
  disabledReason
}: {
  magicLayoutOption: LayoutType;
  disabled: boolean;
  disabledReason: string;
}) {
  const { isActive, handleClick, isDialogOpen, dialogContent, handleConfirm, handleCancel } =
    useMagicLayoutSelection(magicLayoutOption);

  const optionDetails = CLIP_CUSTOMIZER_LAYOUT_TYPES.find(
    option => option.value === magicLayoutOption
  ) as LayoutPopupOption;

  return (
    <>
      <ClipCustomizerMagicLayoutIconButton
        optionDetails={optionDetails}
        trackingId={`customizer-magic-layout-${magicLayoutOption}`}
        onClick={handleClick}
        isDisabled={disabled}
        disabledReason={disabledReason}
        isActive={isActive}
        tooltipPosition={'top'}
      />
      <ConfirmationDialog
        isOpen={isDialogOpen}
        title="Confirm Layout Change"
        content={dialogContent}
        confirmLabel="Continue"
        cancelLabel="Cancel"
        onClose={handleCancel}
        onConfirm={handleConfirm}
      />
    </>
  );
}

export default memo(ClipCustomizerMagicLayoutOption);
